export default __webpack_public_path__ + "static/media/oval_globo.89e4d47b.png";